import request, {METHODS, sviRequest} from '@/api'
import UrlConfig from '@/api/UrlConfigs'
import API from '@/services/typings'
import {get} from 'lodash-es'

/**
 *  酷家乐 - 列表
 */
export const dcpAppUserList = (currentPage, pageSize, params) => {
  return request(`${UrlConfig.PlusCrmWeb.DcpAppUserSearch}/${currentPage}/${pageSize}`, {
    method: METHODS.POST,
    data: params,
  })
}

/**
 *  酷家乐账号-保存
 */
export const dcpAppUserSaveWithResult = (data, url) => {
  //dcpAppUser 新增  dcpAppUser/updateById 编辑
  return request(`/plus-crm-web/${url}`, {
    method: METHODS.POST,
    data,
    raw: true,
  }).then((res: any) => {
    return res
  })
}

/**
 *  酷家乐账号-删除
 */
export const dcpAppUserDeleteById = data => {
  return request(`${UrlConfig.PlusCrmWeb.DcpAppUser}/${data}`, {
    method: METHODS.DELETE,
    data: {},
  }).then((res: any) => {
    return res
  })
}

/**
 *  酷家乐账号-领用账号
 */
export const dcpAppUserGet = params => {
  return request(UrlConfig.PlusCrmWeb.DcpAppUserClaim, {
    method: METHODS.GET,
    params,
    raw: true,
  }).then((res: any) => {
    return res
  })
}

/**
 *  酷家乐账号-释放账号
 */
export const dcpAppUserReturn = params => {
  return request(UrlConfig.PlusCrmWeb.DcpAppUserReturn, {
    method: METHODS.GET,
    params,
    raw: true,
  }).then((res: any) => {
    return res
  })
}

/**
 *  酷家乐账号-保存
 */
export const dcpAppUserAllList = data => {
  return request(UrlConfig.PlusCrmWeb.DcpAppUserSearchList, {
    method: METHODS.POST,
    data,
  }).then((res: any) => {
    // const data = get(res, 'data.data', {})
    return res
  })
}

/**
 *  酷家乐账号-更新酷家乐账户信息
 */
export const dcpAppUserIncrementalSyncKjl2Shj = data => {
  return request(UrlConfig.PlusCrmWeb.DcpAppUserIncrementalSyncKjl2Shj, {
    method: METHODS.POST,
    data,
    raw: true,
  })
}

/**
 *  酷家乐账号-导入
 */
export const dcpAppUserImportInfoExcel = data => {
  return request(UrlConfig.PlusCrmWeb.DcpAppUserBatchImport, {
    method: METHODS.POST,
    data,
    raw: true,
  }).then((res: any) => {
    return res
  })
}

/**
 *  酷家乐 - 领用记录列表
 */
export const dcpHiShjAccountSearchList = (current, pageSize, params) => {
  return request(`${UrlConfig.PlusCrmWeb.DcpHiShjAccountSearch}/${current}/${pageSize}`, {
    method: METHODS.POST,
    data: params,
  }).then((res: any) => {
    // const data = get(res, 'data.data', {})
    const records = get(res, 'list', [])
    const total = get(res, 'count', 0)
    return {records, total}
  })
}

/**
 *  酷家乐 - 领用记录导出
 */
export const dcpHiShjAccount = params => {
  return request(UrlConfig.PlusCrmWeb.DcpHiShjAccountExport, {
    method: METHODS.GET,
    params,
    responseType: 'arraybuffer',
  }).then((res: any) => {
    return res
  })
}

// 线索：去做酷家乐方案
export const generateIframeSrc = (data) => {
  return request(UrlConfig.PlusCrmWeb.GenerateIframeSrc, {
    method: METHODS.POST,
    data,
  })
}
export const dcpDesignInfoSearchKjl = (current, pageSize, data) => {
  return request(UrlConfig.PlusCrmWeb.DcpDesignInfoSearchKjl + '/' + current + '/' + pageSize, {
    method: METHODS.POST,
    data,
  })
}
export const dcpDesignInfoSearchOwnerCompany = (current, pageSize, data) => {
  return request(UrlConfig.PlusCrmWeb.DcpDesignInfoSearchOwnerCompany + '/' + current + '/' + pageSize, {
    method: METHODS.POST,
    data,
  })
}
export const dcpBizOpDesignRelListBizOpDesignInfo = (data) => {
  return request(UrlConfig.PlusCrmWeb.DcpBizOpDesignRelListBizOpDesignInfo, {
    method: METHODS.POST,
    data,
  })
}
export const dcpBizOpDesignRelBindBizOp = (data) => {
  return request(UrlConfig.PlusCrmWeb.DcpBizOpDesignRelBindBizOp, {
    method: METHODS.POST,
    data,
  })
}
export const searchSelfDesignInfo = (data) => {
  return request(UrlConfig.PlusCrmWeb.SearchSelfDesignInfo, {
    method: METHODS.POST,
    data,
  })
}
export const dcpDesignInfoSave = (params) => {
  return request(UrlConfig.PlusCrmWeb.DcpDesignInfoSave, {
    method: METHODS.GET,
    params,
  })
}
export const dcpDesignInfoSave2 = (params) => {
  return request(UrlConfig.PlusCrmWeb.DcpDesignInfoSave2, {
    method: METHODS.GET,
    params,
  })
}

// 美学大师：获取历史版本
export const findByProjectsId = async (option: API.Options) => {
  return await sviRequest(UrlConfig.SviMoa.FindByProjectsId, {
    method: METHODS.POST,
    ...option,
  })
}
// 美学大师：获取方案列表
export const findProjectPageList = async (option: API.Options) => {
  const { pageNo, pageSize } = option.params
  return await sviRequest(
      UrlConfig.SviMoa.FindProjectPageList + `?pageNo=${pageNo}&pageSize=${pageSize}`,
      { method: METHODS.POST, ...option }
  )
}
// 美学大师：获取版本标签
export const findProHistoryPageList = async (option: API.Options) => {
  return await sviRequest(UrlConfig.SviMoa.FindProHistoryPageList + `?pageNo=1&pageSize=9999`, {
    method: METHODS.POST,
    ...option,
  })
}

// 美学大师：添加版本标签
export const updateDealRecommendVersion = async (option: API.Options) => {
  return await sviRequest(UrlConfig.SviMoa.UpdateDealRecommendVersion, {
    method: METHODS.POST,
    ...option,
  })
}

// 美学大师：获取案例名称
export const findCasesById = async (option: API.Options) => {
  return await sviRequest(UrlConfig.SviMoa.FindCasesById, {
    method: METHODS.GET,
    ...option,
  })
}
// 美学大师：编辑案例
export const updateCases = async (option: API.Options) => {
  return await sviRequest(UrlConfig.SviMoa.UpdateCases, { method: METHODS.POST, ...option })
}
// 美学大师：创建案例
export const saveCases = async (option: API.Options) => {
  return await sviRequest(UrlConfig.SviMoa.SaveCases, { method: METHODS.POST, ...option })
}
// 美学大师：修改添加成员
export const updateDashboardUser = async (option: API.Options) => {
  const { casesId } = option.params
  return await sviRequest(UrlConfig.SviMoa.UpdateDashboardUser + `?casesId=${casesId}`, {
    method: METHODS.POST,
    ...option,
  })
}
// 查需求详情
// export const findDetailInfoNoPrivileges = async (option: API.Options) => {
//   const { bizId } = option.params
//   return await request(`/clue-web/crm/common/bizop/findDetailInfoNoPrivileges/${bizId}`, {
//     method: METHODS.POST,
//     ...option,
//   })
// }
// 美学大师：
export const findDashboardUsers = async (option: API.Options) => {
  return await sviRequest(UrlConfig.SviMoa.FindDashboardUsers, {
    method: METHODS.POST,
    ...option,
  })
}

// 获取案例成员
export const fetchMenber = (option: API.Options) => {
  return request(UrlConfig.PlusCrmWeb.FindBizOpRelEmpVo, { method: METHODS.GET, ...option })
}

// 美学大师：删除成员
export const clearDashboardUsers = async (option: API.Options) => {
  return await sviRequest(UrlConfig.SviMoa.ClearDashboardUsers, {
    method: METHODS.POST,
    ...option,
  })
}
export const findMoaFlag = async (id) => {
  return await request(UrlConfig.PlusCrmWeb.FindMoaFlag, {
    method: METHODS.POST,
    data: {bizId: id},
  })
}
export const findBaseBizOpInfoById = async (option: API.Options) => {
  return await request(UrlConfig.PlusCrmWeb.FindBaseBizOpInfoById, {
    method: METHODS.POST,
    ...option,
  })
}
// 美学大师：编辑案例
export const bizEdit = async (option: API.Options) => {
  return await request(UrlConfig.PlusCrmWeb.BizEdit, {
    method: METHODS.POST,
    ...option,
  })
}